import { render, staticRenderFns } from "./cards-container.vue?vue&type=template&id=63c6261e"
import script from "./cards-container.vue?vue&type=script&lang=js"
export * from "./cards-container.vue?vue&type=script&lang=js"
import style0 from "./cards-container.vue?vue&type=style&index=0&id=63c6261e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports